"use client";

import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { useRouter } from "@/hooks/useCompatRouter";
import { Fragment, useEffect, useState } from "react";

import Body from "@/containers/category/Body";
import Top from "@/containers/category/Top";
import useProductsFilter from "@/hooks/useProductsFilter";
import { getBuilderPage } from "@/requests/builder";
import { getProductsByElasticSearch } from "@/requests/product";
import {
  setSearchLoading,
  setSearchProducts,
} from "@/store/features/globalSlice";
import { useAppSelector } from "@/store/hooks";
import { addSlash } from "@/utils";
import { currentPageQuery } from "@/utils/constants";
import { useDispatch } from "react-redux";
import ProductListWidget from "@/containers/category/ProductListWidget";
import PageChange from "@/components/PageChange";

const perPage = 20;
const pid = "product-list-body-12123";

const SearchPage = ({
  builderPage,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const router = useRouter();

  const {
    text,
    search,
    [currentPageQuery]: currentPage,
    ...restQuery
  } = router.query;

  const dispatch = useDispatch();

  const searchQuery = useAppSelector((state) => state.global.searchQuery);
  const searchText = searchQuery || (text ? (Array.isArray(text) ? text.join('/') : text.toString()) : '') || "";
  // const searchText = text?.toString() || "";

  const productsFilter = useProductsFilter(builderPage?.widgets);

  const [products, setProducts] = useState<ProductItemV2[]>([]);
  const [totalProducts, setTotalProducts] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(true);

  const maxPages = Math.ceil(totalProducts / perPage);

  useEffect(() => {
    // const abortController = new AbortController();

    setLoading(true);
    dispatch(setSearchLoading(true));

    // const searchText = searchQuery || text?.toString() || "";

    if (searchText && searchText.length > 0) {
      getProductsByElasticSearch({
        currentPage: +(currentPage ?? 1),
        perPage: productsFilter.perPage || perPage,
        filter: `&search=${addSlash(searchText || "")}`,
        query: restQuery,
        // config: {
        //   signal: abortController.signal,
        // },
      })
        .then((res) => {
          setProducts(res.data);
          setTotalProducts(res.totalResult);
          dispatch(setSearchProducts(res.data?.slice(0, 6)));

          setLoading(false);
          dispatch(setSearchLoading(false));
        })
        .catch((err) => {
          if (err?.code !== "ERR_CANCELED") {
            setLoading(false);
            dispatch(setSearchLoading(false));
          }
          // setLoading(false);
          // dispatch(setSearchLoading(false));
        });
    }

    // const timeout = setTimeout(() => {
    //   const {
    //     text,
    //     search,
    //     [currentPageQuery]: currentPage,
    //     ...restQuery
    //   } = router.query;

    //   if (searchText && searchText.length > 0) {
    //     getProductsByElasticSearch({
    //       currentPage: +(currentPage ?? 1),
    //       perPage: productsFilter.perPage || perPage,
    //       filter: `&search=${addSlash(searchText || "")}`,
    //       query: restQuery,
    //       // config: {
    //       //   signal: abortController.signal,
    //       // },
    //     })
    //       .then((res) => {
    //         setProducts(res.data);
    //         setTotalProducts(res.totalResult);
    //         dispatch(setSearchProducts(res.data?.slice(0, 6)));

    //         setLoading(false);
    //         dispatch(setSearchLoading(false));
    //       })
    //       .catch((err) => {
    //         if (err?.code !== "ERR_CANCELED") {
    //           setLoading(false);
    //           dispatch(setSearchLoading(false));
    //         }
    //         // setLoading(false);
    //         // dispatch(setSearchLoading(false));
    //       });
    //   }
    // }, (!!searchText && searchText.endsWith(" ") ? 0 : 10) as number);

    return () => {
      // clearTimeout(timeout);
      // try {
      //   abortController.signal.throwIfAborted();
      //   if (abortController.signal.aborted === false) abortController.abort();
      // } catch (error) {}
    };
  }, [searchText, currentPage, productsFilter.perPage]);

  // useEffect(() => {
  // 	dispatch(setSearchProducts(products.slice(0, 6)));
  // }, [products, dispatch]);

  const nextPageHandler = (page: number) => {
    const {
      text,
      search,
      [currentPageQuery]: currentPage,
      ...restQuery
    } = router.query;

    const searchTextForHandler = text ? (Array.isArray(text) ? text.join('/') : text.toString()) : '';

    if (searchTextForHandler) {
      dispatch(setSearchLoading(true));

      getProductsByElasticSearch({
        currentPage: page,
        perPage: productsFilter.perPage || perPage,
        filter: `&search=${addSlash(searchTextForHandler)}`,
        query: restQuery,
      })
        .then((res) => {
          productsFilter.setActivePage(page);
          setProducts((prev) => [...prev, ...res.data]);
          setTotalProducts(res.totalResult);
          dispatch(setSearchProducts(res.data?.slice(0, 6)));
        })
        .catch(() => {
          setLoading(false);
          dispatch(setSearchLoading(false));
        })
        .finally(() => {
          setLoading(false);
          // dispatch(setSearchLoading(false));
        });
    }
  };

  return (
    <Fragment key={(searchText || "")+"-search-page-fragment"}>
      <Top
        key={(searchText || "") + "-search-top"}
        brands={[]}
        onFilter={productsFilter.handleFilter}
        breadcrumbs={[
          {
            name: "Home",
            link: { hyperLinkText: "", url: "/", urlType: "page" },
          },
          { name: "Search" },
          {
            name: 'Search results for "' + addSlash(searchText || "") + '"',
          },
        ]}
        productsFilter={productsFilter}
        widgets={builderPage?.topbar || []}
        className="pb-0"
      />

      {/* <Body
        key={(text?.toString() || "") + "-search-body"}
        products={products}
        category={{
          name: `Search results for "${addSlash(searchText || "")}"`,
        }}
        onFilter={productsFilter.handleFilter}
        onUrlFilter={productsFilter.handleFilterByURL}
        total={totalProducts}
        loading={loading}
        hideFilter={true}
        productsFilter={productsFilter}
        loadNextPage={nextPageHandler}
        widgets={builderPage?.widgets || []}
      /> */}

      <div className="container !pb-10 " id={pid} style={{ marginBottom: "20px" }}>
        <div className="w-full flex items-center justify-between py-4 px-5 mb-4 bg-[#F4F4F2] rounded">
          <div>
            <h3 className="flex-1 text-base md:text-xl font-medium text-gray3">
              {`Search results for "${addSlash(searchText || "")}"`}
            </h3>
            <p className="text-xs md:text-sm text-gray3">
              {loading
                ? "Loading..."
                : `${totalProducts} items found ${
                    searchQuery
                      ? `in ${`Search results for "${addSlash(
                          searchText || ""
                        )}"`}`
                      : ""
                  }`}
            </p>
          </div>
        </div>

        <ProductListWidget
          widgets={builderPage?.widgets || []}
          products={products}
          loading={loading}
          activePage={productsFilter.activePage}
          maxCol={perPage}
          perPage={productsFilter.perPage}
          total={totalProducts}
        />
        {/* </Comp> */}

        {totalProducts > 1 && (
          <PageChange
            className="mt-8"
            activePage={productsFilter.activePage}
            setActivePage={(page) => {
              const url = new URLSearchParams();
              url.set(currentPageQuery, page.toString());

              // setActivePage(page);
              productsFilter.handleFilterByURL(url);

              document.getElementById(pid)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            total={maxPages}
            selectPerPage={true}
            // setPerPage={setPerPage}
          />
        )}
      </div>
    </Fragment>
  );
};

export const getServerSideProps: GetServerSideProps<{
  builderPage: BuilderPage | null;
}> = async () => {
  try {
    const builderPage = await getBuilderPage("search");
    return {
      props: {
        builderPage,
      },
    };
  } catch (error) {
    return {
      props: {
        builderPage: null,
      },
    };
  }
};

export default SearchPage;